import type { SVGProps } from 'react';
export const LmsX = ({
  color = '#FF4848',
  ...props
}: SVGProps<SVGSVGElement> & {
  color?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 14 15" {...props} data-sentry-element="svg" data-sentry-component="LmsX" data-sentry-source-file="LmsX.tsx">
    <path fill={color} fillRule="evenodd" d="M12.503 1.866a1.31 1.31 0 0 1 0 1.856L8.834 7.39l3.756 3.756a1.312 1.312 0 1 1-1.856 1.857L6.978 9.247l-3.756 3.756a1.313 1.313 0 0 1-1.856-1.857L5.122 7.39 1.453 3.722A1.313 1.313 0 0 1 3.31 1.866l3.669 3.668 3.669-3.668a1.313 1.313 0 0 1 1.856 0" clipRule="evenodd" data-sentry-element="path" data-sentry-source-file="LmsX.tsx" />
  </svg>;